<script>
    import ImageBank from "../Misc/ImageBank.svelte";
    import ModalButtons from "../Modal/ModalButtons.svelte";
    import { associatedItemsForEntities, createdItemWithEntity } from "../../scripts/wpn2Model.js";
    import dbData from "../../Stores/utilityDBStore.js";

    // ALFX_TODO: Sensor: show images for hydrant as well as sensor
    export let item;
    let imageItems = [];
  	// Options: "show-images", "save-image", "play-video"
    let displayMode = "show-images";
    let fileinput;
    let videoSource;
    let saveImageSrc;

    $: imageItems = associatedItemsForEntities(['Image'], $dbData.all, item, false, false, true, false);
    // See: https://www.w3schools.com/howto/tryit.asp?filename=tryhow_js_slideshow

    function willSaveImage() {
        const createdImageItem = createdItemWithEntity('Image', item.name ?? "", 'Image', item, $dbData);
        const imageFormat = ['jpg', 'jpeg', 'png'].find((x) => saveImageSrc.substring(0, 32).includes(x)) ?? "unknown";
        createdImageItem['format'] = imageFormat.toUpperCase();
        createdImageItem['image_src'] = saveImageSrc;
        imageItems.push(createdImageItem);
        dbData.addOrReplaceItem(createdImageItem);
        displayMode = "show-images";
    }

    // MDN: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
    // Media example: https://dev.to/nelsoncode/how-to-use-the-webcam-with-svelte-js-2415
    async function willShowCamera() {
        console.log("Invoked the camera");
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: true, // { facingMode: { exact: "user" } }   // environment
            });
            videoSource.srcObject = stream;
            videoSource.play();
        } catch (error) {
            console.log(error);
        }
        return;
    }

    // Svelte example, open a file: https://svelte.dev/repl/b17c13d4f1bb40799ccf09e0841ddd90?version=3.46.4
    const onFileSelected = (e) => {
        const saveImageObject = e.target.files[0]
        let reader = new FileReader();
        reader.readAsDataURL(saveImageObject);
        reader.onload = (e) => {
            // Structure of image source: "data:image/png;base64," + <image data as base64 encoded string>
            saveImageSrc = e.target.result;
            displayMode = "save-image";
        }
    };
</script>

<!-- Slideshow container -->
<div class="detail-section">
    {#if displayMode == "show-images"}
        <div class="split-title-buttons">
            <div class="detail-section-title split-view-title">Images</div>
            <div class="right-buttons-panel">
                <a class="active-link" href={"#"} on:click={() => {fileinput.click();}}>File</a>
                <a class="link-spacer" href={"#"}>|</a>
                <a class="inactive-link" href={"#"} on:click={willShowCamera}>Camera</a>
            </div>
            <input style="display:none" type="file" accept=".jpg, .jpeg, .png" on:change={(e) => onFileSelected(e)} bind:this={fileinput}/>
        </div>
        {#if imageItems.length > 0}
            <div class="slideshow-container">
                <ImageBank {imageItems} />
            </div>
        {:else}
            <p>No images yet.</p>
        {/if}
    {:else if displayMode == "save-image"}
        <div class="detail-section slideshow-container">
            <div class="detail-section-title">New Image</div>
            <img
                src={saveImageSrc}
                alt="save with utility"
                class="img-photo"
            />
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={() => (displayMode = "show-images")}
                on:save={willSaveImage}
            />
        </div>
    {:else if displayMode == "play-video"}
        <div class="detail-section slideshow-container">
            <div class="detail-section-title">Take Photo</div>
            <video>
                bind:this={videoSource}
                <track kind="captions" />
            </video>
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={() => (displayMode = "show-images")}
                on:save={willSaveImage}
            />
        </div>
    {/if}
</div>

<style>
    * {
        box-sizing: border-box;
    }
    .slideshow-container {
        text-align: center;
        max-width: 512px;
        position: relative;
        margin: auto;
    }
    .img-photo {
        width: 60%;
    }
</style>
